import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/shared/Breadcrumb.module.css';
import T from '../T';

const ChevronIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export default function Breadcrumb({ items = [] }) {
  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      <Link to="/staff/dashboard" className={styles.breadcrumbLink}><T>Help Center</T></Link>
      
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span className={styles.breadcrumbSep}><ChevronIcon /></span>
          {item.path ? (
            <Link to={item.path} className={styles.breadcrumbLink}><T>{item.label}</T></Link>
          ) : (
            <span className={styles.breadcrumbCurrent}><T>{item.label}</T></span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
